module.exports = __webpack_public_path__ + "static/img/39.5127c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/39.png
// module id = eXVS
// module chunks = 1